/**
 * @file SiteHeader.tsx
 */

"use client";

import { Separator, useSidebar } from "visuais";
import { useHeaderContext } from "visuais";

/**
 * @returns {JSX.Element} Header da sidebar com trigger, logo e área para ações.
 */
export function SiteHeader() {
  const sidebar = useSidebar();
  const { customHeaderComponent } = useHeaderContext();

  // Verifica se o contexto existe antes de desestruturar
  if (!sidebar) {
    return null;
  }

  return (
    <header className="flex h-12 shrink-0 items-center gap-2 transition-[width,height] ease-linear">
      <div className="flex w-full items-center gap-1 pl-4 lg:gap-2 lg:pl-6">
        <div className="ml-auto w-fit flex items-center gap-2">
          {/* Renderiza componente customizado se fornecido */}
          {customHeaderComponent}
        </div>
      </div>
    </header>
  );
}
